define('models/qm/Calibration',[
    'lib/knockout',
    'util/ObservableModel',
    'models/composer/forms/Evaluation',
    'models/User'
], function (ko, ObservableModel, EvaluationForm, User) {
    'use strict';

    var Calibration = ObservableModel.extend({
        modelProperties: {
            evaluationForm: EvaluationForm,
            evaluators: User,
            expertEvaluator: User
        },
        defaults: {
            evaluators: []
        }
    }, function () {});

    return Calibration;
});
